import { useEffect } from 'react';
import { sessionStore } from '@/store/session/store';

export const useResumeSessionValidation = () => {
  useEffect(() => {
    const { expiresAt, scheduleSessionValidation } = sessionStore.getState();

    if (expiresAt && Date.now() < expiresAt) {
      scheduleSessionValidation(expiresAt);
    }

    const handleUnload = () => {
      sessionStore.setState({
        sessionExpired: false,
        isSessionModalOpen: false,
      });
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);
};
